// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Ma2ZC","captionStyle":"styles_captionStyle__3Psi4"};